import React, { useState, useEffect } from 'react';
import contractPartyService from '../../services/contractPartyService.js';
import SelectField from '../common/SelectField.js';
import Alert from '../common/Alert.js';

const AgentPartySelect = ({
  value,
  onChange,
  className = '',
  roleName = 'Agent',
  companyId,
}) => {
  const [parties, setParties] = useState([]);
  const [loading, setLoading] = useState(true);
  const isRequired = roleName === 'Contract Party Admin';

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      try {
        const response = await contractPartyService.getAllUnpaginated({
          status: 'active',
        });
        let list = Array.isArray(response?.data) ? response.data : [];
        const cid = Number(companyId);
        if (companyId !== undefined && companyId !== null && companyId !== '' && !Number.isNaN(cid)) {
          list = list.filter((p) => Number(p.company_id) === cid);
        }
        setParties(list);
      } catch (err) {
        console.error('Failed to load contract parties', err);
        Alert.error(err.response?.data?.error || 'Failed to load contract parties');
        setParties([]);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [companyId]);

  return (
    <div>
      <SelectField
        variant="form"
        label={
          isRequired ? (
            <>
              Contract Party <span className="text-red-500">*</span>
            </>
          ) : (
            <>
              Contract Party <span className="text-gray-400 font-normal">(optional)</span>
            </>
          )
        }
        name="party_id"
        value={value || ''}
        onChange={onChange}
        disabled={loading}
        required={isRequired}
        className={className || 'w-full'}
      >
        {!isRequired && <option value="">Own Company Agent</option>}
        {isRequired && <option value="">Select contract party</option>}
        {parties.map((party) => (
          <option key={party.id} value={String(party.id)}>
            {party.company_name || party.name}
          </option>
        ))}
      </SelectField>
      <p className="text-xs text-gray-500 mt-1">
        {loading
          ? 'Loading contract parties...'
          : parties.length === 0
            ? 'No active contract parties found. Create one under Party Contracts → Contract Party.'
            : isRequired
              ? 'Contract Party Admin must be linked to a contract party.'
              : 'Link agent to a contract party, or leave blank for own-company agent.'}
      </p>
    </div>
  );
};

export default AgentPartySelect;
